<template>
  <div class="card-container">
    <a-row>
      <a-col :span="12">
        <a-menu v-model="current" :default-selected-keys="['train']" mode="horizontal">
          <a-menu-item key="ticket">
            <a :href="'/train-admin/channelShop/policy-ticket?distributorId='+globalDistributorId"
               rel="noopener noreferrer">飞机票</a>
          </a-menu-item>
          <a-menu-item key="train">
            <a :href="'/train-admin/channelShop/policy-train?distributorId='+globalDistributorId"
               rel="noopener noreferrer">火车票</a>
          </a-menu-item>
          <a-menu-item key="hotel">
            <a :href="'/train-admin/channelShop/policy-hotel?distributorId='+globalDistributorId"
               rel="noopener noreferrer">酒店</a>
          </a-menu-item>
        </a-menu>
      </a-col>
      <a-col :span="12">
        <span style="float: right;margin-top:8px;">
          <a-button type="primary" @click="showLevelModal">选择职级</a-button>
        </span>
      </a-col>
    </a-row>

  </div>
  <a-tabs :animated="false" default-active-key="1" @change="callback">
    <a-tab-pane key="1" tab="基础配置">

      <a-form :model="policyForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="超标管控:">
          <a-radio-group v-model:value="policyForm.control">
            <a-radio value="deny">
              允许
            </a-radio>
            <a-radio value="allow">
              不允许
            </a-radio>
            <a-radio value="warn">
              仅提醒
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="超标处理:">
          <a-radio-group v-model:value="policyForm.disposal">
            <a-radio value="approval">
              审批
            </a-radio>
            <a-radio value="payment">
              自付
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="超标原因:">
          <a-radio-group v-model:value="policyForm.reasonRequired">
            <a-radio value="Y">
              必填
            </a-radio>
            <a-radio value="N">
              非必填
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="公告内容" name="notice">
          <a-textarea v-model:value="policyForm.notice"/>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" @click="onSubmit">
            保存修改
          </a-button>
        </a-form-item>
      </a-form>

    </a-tab-pane>
    <a-tab-pane key="2" tab="标准配置">
      <a-row type="flex" justify="center">
        <a-col :span="4">
          职级
        </a-col>
        <a-col :span="4">
          仓等
        </a-col>
        <a-col :span="12">
          管控标准
        </a-col>
        <a-col :span="4">
          操作
        </a-col>
      </a-row>
      <a-row v-for="(trainRoot,rootIndex) in trainData" :key="rootIndex" type="flex" justify="center">
        <a-col :span="4">
          {{ trainRoot.levelName }}
        </a-col>
        <a-col :span="4">
          <a-tag  style="margin: 5px;" v-for="(item,index) in trainRoot.seatsList" :key="index">
            {{
              item.name
            }}
          </a-tag>
        </a-col>
        <a-col :span="12">
          <div v-for="(trainRuleGroup,trainRuleGroupIndex) in trainRoot.policyTrainRuleList" :key="trainRuleGroupIndex">
            <a-row style="margin-bottom: 10px">
              <a-col :span="20">
                <span v-show="false">{{trainRoot}}</span>
                <a-button @click="openPolicyTicketRuleModal(trainRuleGroup,trainRoot)" type="primary" size="small"  style="margin-right: 10px;">
                  添加管控
                </a-button>
              </a-col>
              <a-col :span="4">

              </a-col>
            </a-row>
            <a-table v-if="trainRuleGroup.trainRuleGroupList" :pagination="false" :columns="ticketStandardColumns" :data-source="trainRuleGroup.trainRuleGroupList.ruleList">
              <template v-slot:type="{ text,record,index }">
                <a v-if="record.type === 'city'">城市</a>
                <a v-if="record.type === 'discount'">折扣</a>
              </template>
              <template v-slot:formula="{ text,record,index }">
                <a v-if="record.formula === '()'">包含</a>
                <a v-if="record.formula === '!()'">不包含</a>
                <a v-if="record.formula === '<='">小于等于</a>
                <a v-if="record.formula === '<'">小于</a>
              </template>
              <template v-slot:mileage="{ text,record,index }">
                <div v-if="record.area.length > 0">
                  <a-tag v-for="(item,index) in record.area" :key="item.areaCode" style="margin: 5px;"> {{ item.city }}</a-tag>
                </div>
                <a v-if="record.discount">{{ record.discount }}</a>
              </template>
              <template v-slot:unconformity="{ text,record,index }">
                <a-radio-group v-model:value="record.unconformity" @change="editPolicyTicketRuleList(record,index,trainRuleGroupIndex,rootIndex)">
                  <a-radio value="deny">
                    不允许
                  </a-radio>
                  <a-radio value="warn">
                    仅提醒
                  </a-radio>
                </a-radio-group>
              </template>
              <template v-slot:manage="{ text,record,index }">
                <a @click="putPolicyTicketRuleList(record,index,trainRuleGroupIndex,rootIndex)">删除</a>
              </template>
            </a-table>
          </div>
        </a-col>
        <a-col :span="4">
          <a-button type="danger" size="small" @click="deleteTrainRule(trainRoot)" style="margin-right: 10px;">
            删除
          </a-button>
          <span v-show="false">
            {{ trainRoot.seatsList }}
          </span>
          <a-button type="primary" size="small" @click="editTrainRule(trainRoot)">
            编辑
          </a-button>
        </a-col>
      </a-row>
    </a-tab-pane>
  </a-tabs>
  <a-modal v-model:visible="levelVisible" title="选择职级差标" @ok="selectTrainRuleLevel">
    <a-form :model="policyTrainRuleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="职级">
        <a-radio-group v-model:value="policyTrainRuleForm.levelId">
          <a-radio :disabled="policyTicketRuleFormState === true" :value="item.levelNo" v-for="(item,index) in distributorLevelList" :key="index">
            {{ item.levelName }}
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="舱等">
        <a-checkbox-group v-model:value="policyTrainRuleForm.seats">
          <a-checkbox :value="item.id" v-for="(item,index) in seatsList" :key="index" name="seats">
            {{ item.name }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
  </a-modal>

  <a-modal width="50%" v-model:visible="policyTicketRuleVisible" title="添加管控" @ok="addPolicyTrainRuleList">
    <a-form :model="policyTrainRuleInfoForm" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="管控类型">
        <a-select v-model:value="policyTrainRuleInfoForm.type" placeholder="选择管控类型">
          <a-select-option value="city">
            城市
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="管控城市" v-if="policyTrainRuleInfoForm.type==='city'">
        <a-tabs type="card" @change="selectProvinceChildNode">
          <a-tab-pane v-for="(item,index) in provinceList" :key="item.areaCode" :tab="item.province">
          </a-tab-pane>
        </a-tabs>
        <a-select v-model:value="policyTrainRuleInfoForm.formula" placeholder="管控公式">
          <a-select-option value="()">
            包含
          </a-select-option>
          <a-select-option value="!()">
            不包含
          </a-select-option>
        </a-select>
        <a-checkbox-group v-model:value="policyTrainRuleInfoForm.city">
          <a-checkbox v-if="provinceChildNodeList.length > 0 && provinceChildNodeList[0].provinceLevel==='N'" v-for="(item,index) in provinceChildNodeList" :key="index" :value="item.areaCode" name="city">
            {{ item.city }}
          </a-checkbox>
          <a-checkbox  v-else  :value="provinceChildNodeList[0].areaCode" name="city">
            {{ provinceChildNodeList[0].city }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="不符合时">
        <a-radio-group name="unconformity" v-model:value="policyTrainRuleInfoForm.unconformity">
          <a-radio value="deny">
            不允许
          </a-radio>
          <a-radio value="warn">
            仅提醒
          </a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>

</template>

<script>
import {SmileOutlined, DownOutlined} from '@ant-design/icons-vue';
import {ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import policy from "@axios/policy";
import {notification} from 'ant-design-vue';

export default {
  components: {
    SmileOutlined,
    DownOutlined,
  },
  name: "index",
  setup() {
    const router = useRouter()
    const route = useRoute()
    const business = 10
    const globalDistributorId = route.query.distributorId
    let policyTicketRuleFormState = ref(false)

    /** 城市List **/
    let provinceList = ref([])
    const findPolicyProvince = () => {
      const query = {
        parentId: 0
      }
      policy.getPolicyCity(query).then(p => {
        provinceList.value = p
        if(  p.length > 0 ){
          selectProvinceChildNode(p[0].areaCode)
        }
      })
    }

    /** 子节点城市 **/
    let provinceChildNodeList = ref([])
    const selectProvinceChildNode = (areaCode) => {
      console.log(areaCode)
      policy.getCityChildNode(areaCode).then(c => {
        provinceChildNodeList.value = c
      })
    }



    const ticketColumns = [
      {
        dataIndex: 'levelName',
        title: '职级',
        key: 'levelName',
        width: 150,
        align: 'center',
        slots: {customRender: 'levelName'},
      },
      {
        title: '仓等',
        dataIndex: 'cabinGradeInfo',
        width: 200,
        align: 'center',
        key: 'cabinGradeInfo',
        slots: {customRender: 'cabinGradeInfo'},
      },
      {
        title: '管控标准',
        dataIndex: 'trainRuleGroupList',
        key: 'trainRuleGroupList',
        slots: {customRender: 'trainRuleGroupList'},
      },
      {
        title: '操作',
        key: 'operate',
        width: 200,
        align: 'center',
        dataIndex: 'operate',
        slots: {customRender: 'operate'},
      }
    ]

    let standardColumnsData = ref([])
    const standardColumns = [
      {
        dataIndex: 'type',
        title: '管控类型',
        key: 'type',
        width: 150,
        align: 'center',
        slots: {customRender: 'type'},
      },
      {
        title: '管控条件',
        dataIndex: 'formula',
        width: 200,
        align: 'center',
        key: 'formula',
        slots: {customRender: 'formula'},
      },
      {
        title: '条件规则',
        dataIndex: 'mileage',
        key: 'mileage',
        slots: {customRender: 'mileage'},
      },
      {
        title: '不符合时',
        key: 'unconformity',
        width: 200,
        align: 'center',
        dataIndex: 'unconformity',
        slots: {customRender: 'unconformity'},
      },
      {
        title: '-',
        key: 'manage',
        width: 100,
        align: 'center',
        dataIndex: 'manage',
        slots: {customRender: 'manage'},
      }
    ]

    let policyForm = ref({
      id: null,
      control: null,
      disposal: null,
      reasonRequired: null,
      distributorId: globalDistributorId,
      business: business,
      notice: null
    })
    //基础设置 begin
    const findPolicy = () => {
      const _policyForm = {
        control: policyForm.value.control,
        disposal: policyForm.value.disposal,
        reasonRequired: policyForm.value.reasonRequired,
        distributorId: policyForm.value.distributorId,
        business: policyForm.value.business,
      }
      console.log(_policyForm)
      policy.getPolicy(_policyForm).then(p => {
        policyForm.value = {
          distributorId: p.distributorId,
          control: p.control,
          disposal: p.disposal,
          reasonRequired: p.reasonRequired,
          business: business,
          id: p.id,
          notice: p.notice
        }
        console.log(policyForm)
      })
    }
    findPolicy()
    const onSubmit = () => {
      console.log('submit!', policyForm);
      const _policyForm = policyForm.value
      policy.addAndEditPolicy(_policyForm).then(p => {
        console.log(p)
        openNotification('success', '修改成功.')
      })
    }
    //基础设置 end

    const openNotification = (type, description) => {
      notification[type]({
        message: '提示',
        description: description
      })
    }

    /** 获取机票差标信息 **/
    let trainData = ref([])
    const getPolicyTrainRule = () => {
      const query = {
        distributorId: globalDistributorId,
        business: business
      }
      console.log(query)
      policy.getPolicyTrainRule(query).then(pt => {
        trainData.value = pt
      })
    }
    getPolicyTrainRule()


    /*******/
    let levelVisible = ref(false)

    const defaultPolicyTrainRuleForm = ref({
      levelId: null,
      seats: [],
      layout: "vertical",
      id: null
    })
    let policyTrainRuleForm = ref({
      levelId: null,
      seats: [],
      layout: "vertical",
      id: null
    })
    let distributorLevelList = ref([])

    let seatsList = ref([])
    const showLevelModal = () => {
      policyTrainRuleForm.value = defaultPolicyTrainRuleForm.value
      policyTicketRuleFormState.value = false
      levelVisible.value = true
      let query = {
        distributorId: policyForm.value.distributorId
      }
      policy.getLevelList(query).then(l => {
        distributorLevelList.value = l
      })
      getSeatsList()
    }

    //职级选择
    const selectTrainRuleLevel = (e) => {
      if (policyTrainRuleForm.value.seats.length < 1) {
        return
      }
      const seats = policyTrainRuleForm.value.seats.join(",")
      const ticketRule = {
        policyBaseId: policyForm.value.id,
        distributorId: globalDistributorId,
        levelId: policyTrainRuleForm.value.levelId,
        seats: seats
      }
      console.log(ticketRule)
      policy.addAndEditPolicyTrainRule(ticketRule).then(p => {
        console.log(p)
        getPolicyTrainRule()
      })
      getSeatsList()
      levelVisible.value = false
    }


    const editTrainRule = (trainRoot) => {
      let _seatsList = []
      policyTicketRuleFormState.value = true
      trainRoot.seatsList.forEach(s => {
        _seatsList.push(s.id)
      })
      policyTrainRuleForm.value = {
        levelId: trainRoot.levelId,
        seats: _seatsList,
        layout: "vertical",
        id: trainRoot.id
      }
      levelVisible.value = true
      let query = {
        distributorId: policyForm.value.distributorId
      }
      policy.getLevelList(query).then(l => {
        distributorLevelList.value = l
      })
    }

    const getSeatsList = () => {
      seatsList.value = []
      policy.getPolicyTrainSeats().then(seats => {
        seatsList.value = seats
      })
    }
    getSeatsList()


    const deleteTrainRule = (record) => {
      const deleteParams = {
        policyBaseId: policyForm.value.id,
        distributorId: globalDistributorId,
        id: record.id,
      }
      console.log(deleteParams)
      policy.deletePolicyTrainRule(deleteParams).then(d => {
        console.log(d)
        getPolicyTrainRule()
      })
    }

    const putPolicyTicketRuleList = (record, index, trainRuleGroupIndex, rootIndex) => {
      console.log(record, '-', index, '-', trainRuleGroupIndex, '-', rootIndex)
      trainData.value[rootIndex].policyTrainRuleList[trainRuleGroupIndex].trainRuleGroupList.ruleList.splice(index, 1)
      const _trainData = trainData.value[rootIndex].policyTrainRuleList[trainRuleGroupIndex]
      const policyTicketRuleList = {
        policyTrainRuleId: _trainData.policyTrainRuleId,
        id: _trainData.id,
        controlStandardObject: _trainData.trainRuleGroupList
      }
      policy.putPolicyTrainRuleList(policyTicketRuleList).then(p => {
        console.log(p)
      })
    }

    const editPolicyTicketRuleList = (record, index, trainRuleGroupIndex, rootIndex) => {
      const _trainData = trainData.value[rootIndex].policyTrainRuleList[trainRuleGroupIndex]
      const policyTicketRuleList = {
        policyTrainRuleId: _trainData.policyTrainRuleId,
        id: _trainData.id,
        controlStandardObject: _trainData.trainRuleGroupList
      }
      policy.putPolicyTrainRuleList(policyTicketRuleList).then(p => {
        console.log(p)
      })
    }

    const callback = (key) => {
      console.log(key)
    }

    /** 机票添加模块 **/
    const defaultPolicyTrainRuleInfoForm = ref({
      type: null,
      city: [],
      discount: null,
      formula: null,
      unconformity: 'deny',
      id: null,
      policyTrainRuleId: null
    })

    const policyTicketRuleVisible = ref(false)
    let policyTrainRuleInfoForm = ref({
      type: null,
      city: [],
      discount: null,
      formula: null,
      unconformity: 'deny',
      id: null,
      policyTrainRuleId: null
    })

    const openPolicyTicketRuleModal = (trainRuleGroup, trainRoot) => {
      findPolicyProvince()
      policyTicketRuleVisible.value = true
      if (trainRoot.id) {
        policyTrainRuleInfoForm.value.policyTrainRuleId = trainRoot.id
      }
      if(trainRuleGroup.id !== null){
        policyTrainRuleInfoForm.value.id = trainRuleGroup.id
      }
      console.log(policyTrainRuleInfoForm.value)
    }


    const addPolicyTrainRuleList = () => {
      if (!policyTrainRuleInfoForm.value.policyTrainRuleId) {
        return
      }
      policyTicketRuleVisible.value = false
      const params = {
        policyTrainRuleId: policyTrainRuleInfoForm.value.policyTrainRuleId,
        id: policyTrainRuleInfoForm.value.id,
        controlStandardObject: {
          rule: 'all',
          conditions: true,
          ruleList: [{
            type: policyTrainRuleInfoForm.value.type,
            formula: policyTrainRuleInfoForm.value.formula,
            discount: policyTrainRuleInfoForm.value.discount,
            city: policyTrainRuleInfoForm.value.city,
            unconformity: policyTrainRuleInfoForm.value.unconformity
          }]
        }
      }
      console.log(params,"params------>>>>>")
      policy.addAndEditPolicyTrainRuleInfo(params).then(trainRuleInfo => {
        policyTrainRuleInfoForm.value = defaultPolicyTrainRuleInfoForm.value
        policyTrainRuleInfoForm.value.id = trainRuleInfo.id
        policyTrainRuleInfoForm.value.policyTrainRuleId = trainRuleInfo.policyTrainRuleId
        getPolicyTrainRule()
      })
    }

    return {
      provinceChildNodeList,
      provinceList,
      findPolicyProvince,
      selectProvinceChildNode,
      policyTicketRuleFormState,
      globalDistributorId,
      editTrainRule,
      defaultPolicyTrainRuleInfoForm,
      addPolicyTrainRuleList,
      policyTicketRuleVisible,
      openPolicyTicketRuleModal,
      policyTrainRuleInfoForm,

      editPolicyTicketRuleList,
      callback,
      putPolicyTicketRuleList,
      deleteTrainRule,
      getPolicyTrainRule,
      findPolicy,
      labelCol: {span: 4},
      wrapperCol: {span: 18},
      seatsList,
      distributorLevelList,
      showLevelModal,
      levelVisible: levelVisible,
      policyTrainRuleForm,
      selectTrainRuleLevel,
      policyForm,
      business,
      onSubmit,
      openNotification,
      trainData,
      ticketColumns: ticketColumns,
      ticketStandardColumnsData: standardColumnsData,
      ticketStandardColumns: standardColumns,
      current: ['ticket']
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.ant-tabs-nav-scroll {
  background-color: #F3F3F3;
}

.ant-col-offset-4 {
  margin-left: 100px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>

.ant-menu-item-active {
  background-color: #F3F3F3;
}

.card-container {
  overflow: hidden;
  padding: 0px;
}

.ant-menu-item-selected {
  background-color: #F3F3F3;
  border-bottom: none;
  width: 100px;
}

.ant-menu-item-selected a, .ant-menu-item > a {
  text-align: center;
  font-size: 16px;
}

.ant-menu-item:hover {
  border-bottom: none;
  background-color: #F3F3F3;
}

.ant-menu-item {
  width: 100px;
}

.ant-tabs-nav-wrap, .ant-tabs-nav-scroll {
  background-color: #F3F3F3;
  height: 80px;
}

.ant-tabs-tab-active {
  background-color: #F3F3F3;
}

.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
  margin: 0;
  text-align: center;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

.ant-select {
  padding-bottom: 5px;
}

.ant-checkbox-wrapper {
  margin: 0;
}
</style>
